// helpers
import { amountFormatter } from "/src/lib/helpers";
import { formatEmployeeCount, formatDateFounded, formatBooleanInteger } from '/src/lib/fieldFormatters';

// api
import entityApi from '/src/apis/entityApi';



// local functions

// slider overlay, modified from original bootstrap version to add hide fade as well
const overlayAnimation = (type, user) => {

    // class must be added after delay for the fade animation to work
    const animationDelay = 500;
    const sliderOverlay = document.getElementById('slider-overlay');

    if (type === "show") {

        if (sliderOverlay) {
            handleMenuOverlay(user, type); // must be the 1st action
            sliderOverlay.style.display = 'unset';
            sliderOverlay.style.zIndex = 1;
            setTimeout(function () {
                sliderOverlay.style.opacity = 0.5;
            }, animationDelay);
        }

    } else if (type === "hide") {

        if (sliderOverlay) {
            sliderOverlay.style.opacity = 0;
            setTimeout(function () {
                sliderOverlay.style.display = 'none';
                sliderOverlay.style.zIndex = -1;
                handleMenuOverlay(user, type); // must be the last action
            }, animationDelay);
        }

    }

};

const handleNullValues = (val) => {
    try {
        if (val) {
            return (val);
        } else {
            throw ('error');
        }
    } catch {
        return ("N/A");
    }
};

// exported functions

// prevent logged out 'fixed' menu from overlaying slider
const handleMenuOverlay = (user, type) => {
    try {
        if (!user.is_loggedin) {

            const header = document.getElementById('header-container');
            const spacer = document.getElementById('navbar-spacer');

            if (header) {
                if (type === 'show') {
                    header.classList.remove('fixed-top');
                } else if (type === 'hide') {
                    header.classList.add('fixed-top');
                }
            }

            if (spacer) {
                if (type === 'show') {
                    spacer.style.display = 'none';
                } else if (type === 'hide') {
                    spacer.style.display = 'block';
                }
            }

        }
    } catch (err) {
        console.log(err);
    }
}

export const expandSlider = (user) => {
    const sliderComponent = document.getElementsByClassName("slider-container")[0];
    sliderComponent?.setAttribute('data-expanded', 'true');
    overlayAnimation("show", user);
}

export const closeSlider = (user) => {
    const sliderComponent = document.getElementsByClassName("slider-container")[0];
    sliderComponent?.setAttribute('data-expanded', 'false');
    overlayAnimation("hide", user);

    if (typeof window.jQuery !== 'undefined' && $?.fn?.popover) {
        $('#companyEmailPopover').popover('hide');
    }
}

// company overview data (for header section)
const getCompanyOverview = (entityType, data, directoryType) => {
    const isPrivateEquity = (directoryType === 'private equity');
    let overview = [];
    if (entityType === 'startup') {
        overview.push(
            {
                field: 'Industry',
                value: handleNullValues(data.primary_industry_data && data.primary_industry_data.name)
            },
            {
                field: 'Total Funding',
                value: (data.fund_raised_data && data.fund_raised_data.amount) ?
                    amountFormatter(data.fund_raised_data.amount) : "N/A"
            },
        )
    } else if (entityType === 'investor' && !isPrivateEquity) {
        overview.push(
            {
                field: 'Estimated Deployed Capital',
                value: data.estimated_deployed_capital ? amountFormatter(data.estimated_deployed_capital) : "N/A"
            }
        )
    } else if (entityType === 'corporate' || entityType === 'enabler') {
        overview.push(
            {
                field: 'Total Amount Raised',
                value: (data.fund_raised_data && data.fund_raised_data.amount)
                    ? amountFormatter(data.fund_raised_data.amount)
                    : (data.total_amount_raised ? amountFormatter(data.total_amount_raised) : "N/A")
            }
        )
    } else if (isPrivateEquity) {
        overview.push(
            {
                field: 'Total Amount Raised',
                value: data.total_amount_raised ? amountFormatter(data.total_amount_raised) : "N/A"
            }
        )
    }

    // common to both
    overview.push(
        {
            field: 'Headquarters',
            value: handleNullValues(data.hq_data && data.hq_data.name)
        }
    )

    return (overview);
}

const getCompanyData = (entityType, data) => {
    let info = [];
    if (entityType === 'startup') {
        info.push(
            {
                field: 'Business Type',
                value: (data.business_type_data && data.business_type_data.length > 0) ?
                    data.business_type_data[0].name : "N/A",
                icon: "fas fa-briefcase"
            },
            {
                field: 'No. of Founders',
                value: handleNullValues(data.number_of_founders),
                icon: "fas fa-user-tie"
            },
            {
                field: 'Development Stage',
                value: (data.development_stage_data && data.development_stage_data.name) ?
                    data.development_stage_data.name : "N/A",
                icon: "fas fa-chart-line"
            },
            {
                field: 'Date Founded',
                value: formatDateFounded(data),
                icon: "far fa-calendar"
            },
            {
                field: 'Company Size',
                value: formatEmployeeCount(data),
                icon: "fas fa-users"
            },
            {
                field: 'Active',
                value: formatBooleanInteger(data.is_active),
                icon: "fas fa-power-off"
            }
        )
    } else if (entityType === 'investor' || entityType === 'corporate' || entityType === 'enabler') {
        info.push(
            {
                field: 'Investor Type',
                value: data && data.type_data ? handleNullValues(data.type_data.name) : 'N/A',
                icon: "fas fa-briefcase"
            },
            {
                field: 'No. of Investments',
                value: handleNullValues(data.number_of_investments),
                icon: "fas fa-money-check-alt"
            },
            {
                field: 'Development Stage',
                value: (data.development_stage_data && data.development_stage_data[0] ?
                    handleNullValues(data.development_stage_data[0].name) : 'N/A'),
                icon: "fas fa-chart-line"
            },
            {
                field: 'Number of Funds',
                value: (data.number_of_funds || 'N/A'),
                icon: 'fas fa-search-dollar'
            }
        )
    }
    return (info);
}

export const getCompanyInfo = (entityType, data, directoryType) => {
    return ({
        overview: getCompanyOverview(entityType, data, directoryType),
        data: getCompanyData(entityType, data)
    })
}

export const getDataForSlider = (id, entityType) => {

    // common fields
    let fields = ['id', 'development_stage_data', "website", "twitter", "facebook", "linkedin", "hq_data"];

    // fields for startup directory / ecosystem directory
    if (entityType === 'startup') {
        fields.push('business_type_data', 'number_of_founders', 'date_founded', 'min_num_emp', 'max_num_emp', 'revenue_generating', 'is_active', 'fund_raised_data', 'primary_industry_data');
    } else if (['investor', 'corporate', 'enabler'].includes(entityType)) {
        fields.push('estimated_deployed_capital', 'geo_focus_data', 'industry_data', 'type_data', 'number_of_investments', 'total_amount_raised', 'fund_raised_data', 'number_of_funds');
    }

    return  entityApi.getEntityDetails(id, entityType, fields)
};


